import axios from "axios";
/**
 * 获取授权书
 */
export const fetchAttorney = async <T>(params: { order_ids: string[] }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/publishing-house/get-power-of-attorney-by-apc-orders",
    params
  );
  return result.data;
};
/**
 * 支付用户免密登录
 *
 */
export const fetchAuth = async <T>(params: {
  data: string;
  sign: string;
  token: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/basic/auth",
    params
  );
  return result.data;
};
